import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"mtextbook_use",
    list_id:"mtextbook_use_stu_list",
    x_column_list_arr:[
      {"key":"row_view_row_num","name":"No","width":"50","is_show":"1"},
      {"key":"textbook_title","name":"교재","width":"200","is_show":"1"},
      {"key":"row_view_period","name":"기간","width":"170","is_show":"1"},
      {"key":"row_view_remain_day","name":"남은일","width":"80","is_show":"1"},
      {"key":"row_view_study","name":"학습","width":"80","is_show":"1"},
      {"key":"a_now_page","name":"페이지","width":"80","is_show":"1"},
      {"key":"a_one_day_amount","name":"하루분량","width":"80","is_show":"1"},
      {"key":"row_view_detail","name":"상세","width":"80","is_show":"1"},
      {"key":"row_view_manage","name":"관리","width":"190","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':20,
      'order_id':'',
      'order_type':'',
      's_date_type':'a_date',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_book_seq","a_stu_mcomp_seq","a_stu_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;